module.exports = __webpack_public_path__ + "media/application/images/svgs/headphones-022599aa7c6026926fe65c3fb3be3043.svg";